import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

function EditWorkTime({ row, open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [time, setTime] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (row) {
      setTime(row.duration);
    }
  }, [row]);
  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!time.trim()) newErrors.time = "الوقت مطلوب.";
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const editedMethod = {
      duration: time,
    };
    if (row.duration === editedMethod.duration) {
      toast.error("أنت لم تقم بتعديل أي شيء!");
      return;
    }
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/worktime/${row.id}`,
        editedMethod,
        {
          withCredentials: true,
        }
      );

      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم تعديل مدة العمل بنجاح!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: "300px",
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">تعديل مدة العمل</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="المدة"
            type="text"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            error={!!errors.time}
            helperText={errors.time}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          تعديل
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditWorkTime;
